@if (loaded && count && count > 0) {
<div class="mdc-layout-grid">
  <div class="mdc-layout-grid__inner">
    <div class="mdc-layout-grid__cell mdc-layout-grid__cell--span-12 load-more__wrapper">
      <button mat-button class="load-more" (click)="onLoadMore()">
        <mat-icon class="load-more__icon">refresh</mat-icon>
        <span class="load-more__text" i18n="@@featureNewsfeed-loadMoreButton">Mehr laden</span>
      </button>
    </div>
  </div>
</div>
}
